"use strict";

exports.__esModule = true;
exports.Notification = void 0;
var _core = require("@blueprintjs/core");
/** Singleton toaster instance (a Promise, per Blueprint v6's async create API). */
var Notification = exports.Notification = _core.OverlayToaster.create({
  className: "app-notification",
  position: _core.Position.TOP
});